import { parseFacebookVideoUrl, parseYoutubeVideoUrl } from '#shared/media'
import { test } from 'last-validator'

export const isURLVideo = test((value) => {
    return Boolean(
        parseYoutubeVideoUrl(value, 'content') ||
            parseFacebookVideoUrl(value, 'content') ||
            parseYoutubeVideoUrl(value, 'recording') ||
            parseFacebookVideoUrl(value, 'recording')
    )
}, 'Nesprávne zadaná URL adresa, prosím zadajte ako https://www.youtube.com/watch?v=VIDEO_ID, https://fb.watch/VIDEO_ID, https://www.facebook.com/ID/videos/VIDEO_ID alebo https://www.facebook.com/facebook/videos/VIDEO_ID')
